import NImage from '@base/Image';

import {
  ContentLineWrapper,
  ContentWrapper,
  CoverWrapper,
  ImageWrapper,
  StyledCenterDivider,
  StyledH3,
  StyledP1,
  StyledSecP1
} from './styles';

const CentersCover = () => {
  return (
    <CoverWrapper>
      <StyledH3>Ace your preparation at our Unacademy Centre</StyledH3>
      <ImageWrapper>
        <NImage
          src="offline-centres/postpayment/centers-covers.svg"
          layout="fill"
          alt="illustration"
        />
      </ImageWrapper>

      <StyledCenterDivider />
      <ContentWrapper>
        <StyledP1>
          Experience offline learning with an added online advantage
        </StyledP1>
        <ContentLineWrapper>
          <NImage
            src="offline-centres/postpayment/checkmark.svg"
            alt="checkmark"
            height={18}
            width={18}
          />
          <StyledSecP1>
            Learn face-to-face from the best educators in your city
          </StyledSecP1>
        </ContentLineWrapper>
        <ContentLineWrapper>
          <NImage
            src="offline-centres/postpayment/checkmark.svg"
            alt="checkmark"
            height={18}
            width={18}
          />
          <StyledSecP1>
            Access high-tech library, spacious classrooms, cafe and more
          </StyledSecP1>
        </ContentLineWrapper>
        <ContentLineWrapper>
          <NImage
            src="offline-centres/postpayment/checkmark.svg"
            alt="checkmark"
            height={18}
            width={18}
          />
          <StyledSecP1>Regular educator-parent connect</StyledSecP1>
        </ContentLineWrapper>
      </ContentWrapper>
    </CoverWrapper>
  );
};

export default CentersCover;
